export const GET_CHAT_LOGS_REQUEST = 'GET_CHAT_LOGS_REQUEST';
export const GET_CHAT_LOGS_SUCCESS = 'GET_CHAT_LOGS_SUCCESS';
export const GET_CHAT_LOGS_ERROR = 'GET_CHAT_LOGS_ERROR';
